import { Injectable } from '@angular/core';
import { Resolve, Router, ActivatedRouteSnapshot } from '@angular/router';
import { Platform } from '@angular/cdk/platform';

import { AccountService } from '../../+state';

@Injectable()
export class LoginResolver implements Resolve<void> {
  constructor(
    private accountService: AccountService,
    private platform: Platform,
    private router: Router
  ) {}

  resolve(route: ActivatedRouteSnapshot) {
    const token = route.paramMap.get('token');
    const failed = route.paramMap.get('failed');

    if (!this.platform.isBrowser) {
      return;
    } else if (token) {
      // http://localhost:4200/login/abcxyz
      this.accountService.lockerUrlLogin(token);
    } else if (failed) {
      // http://localhost:4200/login;failed=1#_=_
      this.accountService.socialLoginFailed();
    } else {
      this.router.navigateByUrl('/');
    }
  }
}
